export default __webpack_public_path__ + "e2b31c9928c479a9d17e7c4cd2b08872.svg";